<!--
  @description 告警管理
  @author lixiaohua
  @date 2021/08/07
-->
<template>
  <div class="dutyManagement__content">
    <el-form ref="searchForm"
      :model="searchForm"
      :inline="true">
      <el-form-item :label="$t('dutyManagement.table.operators')"
        input-width="auto">
        <g-select :list="operatorslList"
          :defaultAll="true"
          v-model="searchForm.operators"></g-select>
      </el-form-item>
      <el-form-item :label="$t('common.time')"
        input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="yyyy-MM-dd HH:mm"
            style="width: 180px;"
            v-model="searchForm.startTime"
            type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime"
          style="margin-left: 10px">
          <el-date-picker value-format="yyyy-MM-dd HH:mm"
            style="width: 180px;"
            v-model="searchForm.endTime"
            type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
          @click="e_search"
          v-g-rac="gRac('dutyManagement@search')"
          v-text="$t('common.search')"></el-button>
        <el-button type="primary"
          @click="e_add"
          v-g-rac="gRac('dutyManagement@add')"
          v-text="$t('dataDictionary.addTo')"></el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-table-extend :data="tData"
        :head="tHead"
        :currentChange="tCurrentChange"
        :sizeChange="tSizeChange"
        border>
        <template slot="control-column"
          slot-scope="{data}">
          <el-table-extend-control :control="tableControl"
            :data="data"
            :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
    </div>
    <el-dialog :closeOnClickModal="false"
      :title="dialogTitle"
      :visible.sync="dialogFormShow"
      width="800px">
      <el-form :model="dialogFormData"
        label-position="right"
        ref="dialogFormData">
        <el-form-item input-width="750px">
          <div class="table__block">
            <table class="table__table">
              <thead>
                <tr>
                  <th>{{$t('alarmQuery.startTime')}}</th>
                  <th>{{$t('alarmQuery.endTime')}}</th>
                  <th>{{$t('dutyManagement.table.operators')}}</th>
                  <th v-if="isAddOrEdit == 'add'">
                    <el-button type="primary"
                      @click="e_addTable">{{$t('dutyManagement.add')}}</el-button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data,index) in dialogFormData.tableData"
                  :key="index">
                  <td class="table__td">
                    <el-form-item :prop="'tableData.' + index + '.startTime'"
                      :rules="{...dialogRule}">
                      <el-date-picker format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        style="width: 180px;"
                        v-model="data.startTime"
                        type="datetime">
                      </el-date-picker>
                    </el-form-item>
                  </td>
                  <td class="table__td">
                    <el-form-item :prop="'tableData.' + index + '.endTime'"
                      :rules="{...dialogRule}">
                      <el-date-picker format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        style="width: 180px;"
                        v-model="data.endTime"
                        type="datetime">
                      </el-date-picker>
                    </el-form-item>
                  </td>
                  <td class="table__td td_operator">
                    <el-form-item :prop="'tableData.' + index + '.operators'"
                      :rules="{...operatorsRule}">
                      <el-select v-model="data.operators"
                        multiple
                        collapse-tags
                        style="width: 280px;">
                        <el-option v-for="(sitem, skey) in operatorslList"
                          :key="skey"
                          :label="sitem"
                          :value="skey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td v-if="isAddOrEdit == 'add'">
                    <el-button type="primary"
                      @click="e_delTable(data,index)">{{$t("common.delete")}}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer"
        class="dialog-footer">
        <el-button @click="e_tableCancel">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
          v-if="isAddOrEdit == 'add'"
          @click="e_tableSave">{{$t('common.save')}}</el-button>
        <el-button type="primary"
          v-if="isAddOrEdit == 'edit'"
          @click="e_updateConfirm">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import rac from "@/plugins/rac-mixin";
import dic from "@/components/mixins/dic";
import table from "@/components/mixins/table";
import dutyManageBiz from "@/logic/statistics/dutyManagementBiz";
import validateConfig from "@/utils/validate";
import TimeFormat from "@/utils/timeFormat";
import { extend } from "@/utils/tool";

const __baseTableData = {
  startTime: "",
  endTime: "",
  operators: []
};
export default {
  mixins: [rac, table, dic],
  data() {
    const that = this;
    return {
      isAddOrEdit: "",
      dialogTitle: "",
      operatorslList: {},
      dialogFormShow: false,
      dialogRule: { ...validateConfig.common.notEmpty },
      dialogFormData: { tableData: [{ ...__baseTableData }] },
      searchForm: extend({}, __baseTableData, { operators: "" }),
      operatorsRule: extend({}, validateConfig.common.notEmpty, {
        trigger: "change",
        type: "array"
      }),
      tableControl: [
        {
          label: that.$t("common.edit"),
          callback: that.e_update,
          rac: () => that.gRac("dutyManagement@update")
        }
      ]
    };
  },
  components: {},
  computed: {},
  methods: {
    async preInitTable() {
      await Promise.all([
        dutyManageBiz.getUsers().then(data => {
          let res = {};
          data.map(item => {
            res[item.userName] = item.userName;
          });
          this.operatorslList = { ...res };
        })
      ]);
      this.initTable();
    },
    initTable() {
      const that = this;
      this.tInitTable({
        lanKey: "dutyManagement.table",
        head: ["startTime", "endTime", "operators"],
        requestFun: this.search,
        headOpt: {
          startTime: {
            formatter: "Date"
          },
          endTime: {
            formatter: "Date"
          }
        }
      });
    },
    search() {
      let reqData = extend(true, { ...this.tPageInfo }, this.searchForm, {
        endTime: TimeFormat.formatTimeTolong(this.searchForm.endTime),
        startTime: TimeFormat.formatTimeTolong(this.searchForm.startTime)
      });
      reqData = this.removeBlank(reqData);
      dutyManageBiz.getDutyList(reqData).then(data => {
        data.dataList = data.dataList.map(item => {
          if (item.operators) item.operators = item.operators.toString();
          return item;
        });
        this.tData = data;
      });
    },
    removeBlank(data) {
      Object.keys(data).map(item => {
        if (data[item] === "") {
          delete data[item];
        }
      });
      return data;
    },
    sucTip() {
      this.$message({
        message: this.$t("common.success"),
        type: "success"
      });
    },
    format(da) {
      return da.map(item => {
        for (let i in item) {
          if (/time|date/gi.test(i))
            item[i] = TimeFormat.formatTimeTolong(item[i]);
        }
        return item;
      });
    },
    resetFields(ref = "dialogFormData") {
      this.$nextTick(() => {
        this.$refs[ref].resetFields();
      });
    },
    setTableData(da) {
      this.dialogFormData.tableData = [];
      this.$nextTick(() => {
        this.dialogFormData.tableData.push({ ...da });
      });
    },
    e_add() {
      this.dialogFormShow = true;
      this.dialogTitle = this.$t("common.add");
      this.isAddOrEdit = "add";
      this.setTableData(__baseTableData);
      this.resetFields();
    },
    e_search() {
      this.tResetPage();
      this.search();
    },
    e_update(row, index, data) {
      const _row = { ...row };
      _row.operators = _row.operators && _row.operators.split(",");
      this.dialogFormShow = true;
      this.dialogTitle = this.$t("common.edit");
      this.isAddOrEdit = "edit";
      this.setTableData(_row);
      this.resetFields();
    },
    e_updateConfirm() {
      const params = {
        id: this.dialogFormData.tableData[0].id,
        ...this.format(extend(true, [], this.dialogFormData.tableData))[0]
      };
      this.$refs.dialogFormData.validate(valid => {
        if (!valid) return;
        dutyManageBiz.updateDuty(params).then(() => {
          this.sucTip();
          this.dialogFormShow = false;
          this.e_search();
        });
      });
    },
    e_delTable(da, index) {
      if (this.dialogFormData.tableData.length > 1)
        this.dialogFormData.tableData.splice(index, 1);
    },
    e_addTable() {
      this.dialogFormData.tableData.push({ ...__baseTableData });
    },
    e_tableCancel() {
      this.dialogFormShow = false;
    },
    e_tableSave() {
      const params = {
        onDutyList: this.format(extend(true, [], this.dialogFormData.tableData))
      };
      this.$refs.dialogFormData.validate(valid => {
        if (!valid) return;
        dutyManageBiz.saveDuty(params).then(() => {
          this.sucTip();
          this.e_search();
          this.dialogFormShow = false;
        });
      });
    }
  },
  watch: {},
  mounted() {
    this.preInitTable();
    this.e_search();
  }
};
</script>
<style scoped>
.table__td {
  padding-right: 10px;
}
.td_operator {
  width: 280px;
}
</style>